<template>
	<div>
		<div class="main-page-content">
			<el-form :inline="true" :model="searchCondition" class="search-form">
				<el-form-item label="标题">
					<el-input
						v-model="searchCondition.title"
						placeholder="请输入标题"
						clearable
					></el-input>
				</el-form-item>
				<el-form-item label="短剧类型">
					<el-input
						v-model="searchCondition.category_type"
						placeholder="请输入短剧类型"
						clearable
					></el-input>
				</el-form-item>
				<el-form-item label="审核状态">
					<el-select
						v-model="searchCondition.audit_status"
						placeholder="请选择审核状态"
						clearable
					>
						<el-option
							v-for="item in auditOptions"
							:key="item.value"
							:label="item.label"
							:value="item.value"
						></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="发布人">
					<el-input
						v-model="searchCondition.fullname"
						placeholder="请输入发布人"
						clearable
					></el-input>
				</el-form-item>
				<el-form-item label="创建时间">
					<DatePicker :value="dateRange" @dataSearch="dataSearch" />
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="searchButton">查询</el-button>
					<el-button @click="resetSearch">重置</el-button>
				</el-form-item>
			</el-form>

			<div class="table-actions">
				<el-button type="primary" size="small" @click="viewAllJoinList"
					>总报名记录</el-button
				>
			</div>

			<el-table
				v-loading="loading"
				:data="tableData"
				style="width: 100%"
				:header-cell-style="{ background: '#fbfbfb' }"
			>
				<el-table-column
					prop="title"
					label="标题"
					min-width="160"
					align="center"
					show-overflow-tooltip
				></el-table-column>
				<el-table-column
					prop="fullname"
					label="发布人"
					width="120"
					align="center"
					show-overflow-tooltip
				></el-table-column>
				<el-table-column
					prop="category_type"
					label="短剧类型"
					width="110"
					align="center"
				></el-table-column>
				<el-table-column label="薪资范围" width="150" align="center">
					<template slot-scope="scope">{{ formatSalary(scope.row) }}</template>
				</el-table-column>
				<el-table-column
					prop="order_start_time"
					label="开始时间"
					width="160"
					align="center"
				></el-table-column>
				<el-table-column
					prop="order_end_time"
					label="结束时间"
					width="160"
					align="center"
				></el-table-column>
				<el-table-column label="制作周期" width="90" align="center">
					<template slot-scope="scope">{{
						scope.row.production_cycle || "-"
					}}</template>
				</el-table-column>
				<el-table-column label="封面" width="90" align="center">
					<template slot-scope="scope">
						<img
							v-if="scope.row.cover"
							class="cover-img"
							:src="scope.row.cover"
							@click="previewCover(scope.row.cover)"
						/>
						<span v-else>-</span>
					</template>
				</el-table-column>
				<el-table-column label="审核状态" width="100" align="center">
					<template slot-scope="scope">
						<el-tag :type="auditTagType(scope.row.audit_status)">{{
							auditStatusText(scope.row.audit_status)
						}}</el-tag>
					</template>
				</el-table-column>
				<el-table-column
					prop="audit_reject_reason"
					label="拒绝原因"
					min-width="140"
					align="center"
					show-overflow-tooltip
				></el-table-column>
				<el-table-column
					prop="join_count"
					label="报名人数"
					width="90"
					align="center"
				></el-table-column>
				<el-table-column
					prop="created_at"
					label="创建时间"
					width="160"
					align="center"
				></el-table-column>
				<el-table-column label="操作" width="230" align="center" fixed="right">
					<template slot-scope="scope">
						<el-button size="mini" @click="viewDetail(scope.row)"
							>详情</el-button
						>
						<el-button
							v-if="scope.row.audit_status == 0"
							size="mini"
							type="primary"
							@click="openAudit(scope.row)"
							>审核</el-button
						>
						<el-button size="mini" type="text" @click="viewJoinList(scope.row)"
							>报名记录</el-button
						>
					</template>
				</el-table-column>
			</el-table>

			<el-pagination
				class="pagination"
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page.sync="page.current_page"
				:page-sizes="[10, 20, 50, 100]"
				:page-size="page.page_size"
				layout="total, sizes, prev, pager, next, jumper"
				:total="page.total"
			></el-pagination>
		</div>

		<el-dialog title="AI订单详情" :visible.sync="detailVisible" width="720px">
			<div class="detail-grid">
				<div class="detail-item">
					<span>标题：</span>{{ detailData.title || "-" }}
				</div>
				<div class="detail-item">
					<span>短剧类型：</span>{{ detailData.category_type || "-" }}
				</div>
				<div class="detail-item">
					<span>薪资范围：</span>{{ formatSalary(detailData) }}
				</div>
				<div class="detail-item">
					<span>制作周期：</span>{{ detailData.production_cycle || "-" }}
				</div>
				<div class="detail-item">
					<span>开始时间：</span>{{ detailData.order_start_time || "-" }}
				</div>
				<div class="detail-item">
					<span>结束时间：</span>{{ detailData.order_end_time || "-" }}
				</div>
				<div class="detail-item">
					<span>发布人：</span>{{ detailData.fullname || "-" }}
				</div>
				<div class="detail-item">
					<span>报名人数：</span>{{ detailData.join_count || 0 }}
				</div>
				<div class="detail-item">
					<span>审核状态：</span>{{ auditStatusText(detailData.audit_status) }}
				</div>
				<div class="detail-item">
					<span>审核时间：</span>{{ detailData.audit_time || "-" }}
				</div>
				<div class="detail-item detail-item-full">
					<span>拒绝原因：</span>{{ detailData.audit_reject_reason || "-" }}
				</div>
				<div class="detail-item detail-item-full">
					<span>订单描述：</span>{{ detailData.description || "-" }}
				</div>
				<div class="detail-item detail-item-full">
					<span>封面：</span>
					<img
						v-if="detailData.cover"
						class="detail-cover"
						:src="detailData.cover"
						@click="previewCover(detailData.cover)"
					/>
					<span v-else>-</span>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="detailVisible = false">关 闭</el-button>
			</span>
		</el-dialog>

		<el-dialog title="AIGC订单审核" :visible.sync="auditVisible" width="520px">
			<el-form :model="auditForm" label-width="110px">
				<el-form-item label="审核结果">
					<el-radio-group v-model="auditForm.audit_status">
						<el-radio :label="1">审核通过</el-radio>
						<el-radio :label="2">审核拒绝</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item
					v-if="auditForm.audit_status == 2"
					label="拒绝原因"
					required
				>
					<el-input
						v-model="auditForm.audit_reject_reason"
						type="textarea"
						placeholder="请输入拒绝原因"
						maxlength="200"
						show-word-limit
						:rows="4"
					></el-input>
				</el-form-item>
				<el-form-item label="封面地址">
					<UploadImg
						ref="coverUploadRef"
						:uploadProps="coverUploadProps"
						@successFile="handleCoverUploadSuccess"
						@removeFile="handleCoverUploadRemove"
					/>
					<div class="upload-tip">
						请上传一张封面图片，非必填，上传后会更新封面。
					</div>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="auditVisible = false">取 消</el-button>
				<el-button
					type="primary"
					:loading="auditSubmitting"
					@click="submitAudit"
					>确 定</el-button
				>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import DatePicker from "@/components/DatePicker.vue";
import UploadImg from "@/components/uploadImg/index.vue";

export default {
	name: "KhlAiOrderListContent",
	components: {
		DatePicker,
		UploadImg,
	},
	data() {
		return {
			loading: false,
			auditSubmitting: false,
			tableData: [],
			searchCondition: {},
			dateRange: [],
			page: {
				current_page: 1,
				page_size: 10,
				total: 0,
			},
			auditOptions: [
				{ label: "待审核", value: 0 },
				{ label: "审核通过", value: 1 },
				{ label: "审核拒绝", value: 2 },
			],
			detailVisible: false,
			detailData: {},
			auditVisible: false,
			coverUploadProps: {
				maxSize: 2,
				limit: 1,
			},
			auditForm: {
				id: "",
				audit_status: 1,
				audit_reject_reason: "",
				cover: "",
				cover_url: "",
				cover_file: "",
			},
		};
	},
	watch: {
		"$route.matched": function(n) {
			if (n.length === 2) {
				this.init();
			}
		},
	},
	created() {
		this.init();
	},
	methods: {
		searchButton() {
			this.page.current_page = 1;
			this.init();
		},
		resetSearch() {
			this.searchCondition = {};
			this.dateRange = [];
			this.searchButton();
		},
		dataSearch(value) {
			this.dateRange = value || [];
			if (this.dateRange.length) {
				this.searchCondition.start_time = this.dateRange[0];
				this.searchCondition.end_time = this.dateRange[1];
			} else {
				delete this.searchCondition.start_time;
				delete this.searchCondition.end_time;
			}
		},
		handleSizeChange(val) {
			this.page.page_size = val;
			this.page.current_page = 1;
			this.init();
		},
		handleCurrentChange(val) {
			this.page.current_page = val;
			this.init();
		},
		handleSearchCondition() {
			let condition = {};
			["title", "category_type", "fullname", "start_time", "end_time"].forEach(
				(key) => {
					if (this.searchCondition[key]) {
						condition[key] = this.searchCondition[key];
					}
				},
			);
			if (
				this.searchCondition.audit_status === 0 ||
				this.searchCondition.audit_status
			) {
				condition.audit_status = this.searchCondition.audit_status;
			}
			return condition;
		},
		async init() {
			this.loading = true;
			let params = Object.assign({}, this.handleSearchCondition(), {
				current_page: this.page.current_page,
				page_size: this.page.page_size,
			});
			try {
				let res = await this.$api.getKhlAiOrderList(params);
				this.tableData = res.data || [];
				this.page = Object.assign({}, this.page, res.pages || {});
			} finally {
				this.loading = false;
			}
		},
		async viewDetail(row) {
			let info = await this.$api.getKhlAiOrderInfo({ id: row.id });
			this.detailData = info || {};
			this.detailVisible = true;
		},
		openAudit(row) {
			this.auditForm = {
				id: row.id,
				audit_status: 1,
				audit_reject_reason: "",
				cover: "",
				cover_url: "",
				cover_file: "",
			};
			this.auditVisible = true;
			this.$nextTick(() => {
				if (this.$refs.coverUploadRef) {
					this.$refs.coverUploadRef.setImagesList(row.cover ? [row.cover] : []);
				}
			});
		},
		handleCoverUploadSuccess(url) {
			let coverUrl = url || "";
			this.auditForm.cover = coverUrl;
			this.auditForm.cover_url = coverUrl;
		},
		handleCoverUploadRemove() {
			this.auditForm.cover = "";
			this.auditForm.cover_url = "";
		},
		async submitAudit() {
			if (
				this.auditForm.audit_status == 2 &&
				!this.auditForm.audit_reject_reason
			) {
				this.$message.error("请输入拒绝原因");
				return;
			}
			let params = {
				id: this.auditForm.id,
				audit_status: this.auditForm.audit_status,
			};
			if (this.auditForm.audit_status == 2) {
				params.audit_reject_reason = this.auditForm.audit_reject_reason;
			}
			if (this.auditForm.cover) {
				params.cover = this.auditForm.cover;
			}
			if (this.auditForm.cover_url) {
				params.cover_url = this.auditForm.cover_url;
			}
			if (this.auditForm.cover_file) {
				params.cover_file = this.auditForm.cover_file;
			}
			this.auditSubmitting = true;
			try {
				let result = await this.$api.auditKhlAiOrder(params);
				if (result) {
					this.$message.success("审核成功");
					this.auditVisible = false;
					this.init();
				} else {
					this.$message.warning("未更新审核状态");
				}
			} finally {
				this.auditSubmitting = false;
			}
		},
		viewJoinList(row) {
			this.$router.push({
				path: "/khl_ai_order/join",
				query: {
					ai_order_id: row.id,
					order_no: row.order_no,
					title: row.title,
				},
			});
		},
		viewAllJoinList() {
			this.$router.push({
				path: "/khl_ai_order/join",
			});
		},
		previewCover(url) {
			window.open(url, "_blank");
		},
		formatSalary(row) {
			if (!row || (!row.min_salary && !row.max_salary)) {
				return "-";
			}
			return `${row.min_salary || "-"} - ${row.max_salary ||
				"-"}元/${row.salary_unit || ""}`;
		},
		auditStatusText(status) {
			let item = this.auditOptions.find((option) => option.value == status);
			return item ? item.label : "-";
		},
		auditTagType(status) {
			if (status == 1) {
				return "success";
			}
			if (status == 2) {
				return "danger";
			}
			return "warning";
		},
	},
};
</script>

<style scoped lang="scss">
.main-page-content {
	background: #fff;
	padding: 20px;
	padding-bottom: 60px;
}

.search-form {
	margin-bottom: 12px;
}

.table-actions {
	display: flex;
	justify-content: flex-end;
	margin-bottom: 12px;
}

.upload-tip {
	color: #909399;
	font-size: 12px;
	line-height: 20px;
}

.cover-img {
	width: 48px;
	height: 48px;
	object-fit: cover;
	cursor: pointer;
	border-radius: 4px;
}

.pagination {
	float: right;
	margin-top: 20px;
}

.detail-grid {
	display: flex;
	flex-wrap: wrap;
}

.detail-item {
	width: 50%;
	line-height: 32px;
	word-break: break-all;
}

.detail-item span {
	color: #606266;
	font-weight: bold;
}

.detail-item-full {
	width: 100%;
}

.detail-cover {
	width: 120px;
	height: 120px;
	object-fit: cover;
	cursor: pointer;
	vertical-align: top;
	border-radius: 4px;
}
</style>
